import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IPartnerFlagsChangeRequestResult } from 'partner360/models/partnerFlagRequests/IPartnerFlagsChangeRequestResult'
import { TFlagChangeRequestStatus } from 'partner360/models/partnerFlagRequests/TFlagChangeRequestStatus'

export const changeRequestStatus = async (
  requestId: number,
  status: TFlagChangeRequestStatus
): Promise<IPartnerFlagsChangeRequestResult> => {
  const url = proxy('/webservice/621/sp/v3/spJBPTopPartnerFlagsRequestSetStatus/call')
  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const payload = {
    'p.RequestId': requestId,
    'p.Status': status,
  }

  const response = await Rest.post({ url, payload, headers })

  return response.Rows[0]
}
